import { gql } from '@apollo/client';

/**
 * AOI 业务标签字典 (枚举在 map-api, 由 map-service 展开, BFF 透传)。
 *
 * <p>停用的标签也会返回 (enabled=false): 前端置灰而不是隐藏 —— 已打了该标签的面还要能看懂。
 * allowedDbLevels 走 DB 口径 (0 = 1 级楼栋 / 1 = 2 级小区), 与 detail.level 同一套。
 */
export const LIST_AOI_BIZ_TAG_DICTIONARY = gql`
  query ListAoiBizTagDictionary {
    listAoiBizTagDictionary {
      code
      zhName
      description
      kind
      runtimeMatch
      allowedDbLevels
      enabled
      actions {
        code
        zhName
        needsPreview
        needsConfirm
      }
    }
  }
`;

export interface AoiBizTagActionDictItem {
    code: string;
    zhName: string;
    needsPreview: boolean;
    needsConfirm: boolean;
}

export interface AoiBizTagDictItem {
    code: string;
    zhName: string;
    description: string | null;
    /** FACT=事实 / POLICY=策略 */
    kind: string;
    runtimeMatch: boolean;
    /** DB 口径: 0 = 1 级(楼栋) / 1 = 2 级(小区) */
    allowedDbLevels: number[];
    enabled: boolean;
    actions: AoiBizTagActionDictItem[];
}

export interface ListAoiBizTagDictionaryResponse {
    listAoiBizTagDictionary: AoiBizTagDictItem[];
}
